/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const DOCUMENT_ADD_REQUEST = 'DOCUMENT_ADD_REQUEST';
export const DOCUMENT_ADD_REQUEST_SUCCESS = 'DOCUMENT_ADD_REQUEST_SUCCESS';
export const DOCUMENT_ADD_REQUEST_FAILURE = 'DOCUMENT_ADD_REQUEST_FAILURE';

export const DOCUMENTS_FETCH_REQUEST = 'DOCUMENTS_FETCH_REQUEST';
export const DOCUMENTS_FETCH_REQUEST_SUCCESS = 'DOCUMENTS_FETCH_REQUEST_SUCCESS';
export const DOCUMENTS_FETCH_REQUEST_FAILURE = 'DOCUMENTS_FETCH_REQUEST_FAILURE';

export const DOCUMENT_CLEAN_REQUEST = 'DOCUMENT_CLEAN_REQUEST';

export const SINGLE_DOCUMENTS_FETCH_REQUEST = 'SINGLE_DOCUMENTS_FETCH_REQUEST';
export const SINGLE_DOCUMENTS_FETCH_REQUEST_SUCCESS = 'SINGLE_DOCUMENTS_FETCH_REQUEST_SUCCESS';
export const SINGLE_DOCUMENTS_FETCH_REQUEST_FAILURE = 'SINGLE_DOCUMENTS_FETCH_REQUEST_FAILURE';

export const DOCUMENT_YEARS_FETCH_REQUEST_FAILURE = 'DOCUMENT_YEARS_FETCH_REQUEST_FAILURE';
export const DOCUMENT_YEARS_FETCH_REQUEST = 'DOCUMENT_YEARS_FETCH_REQUEST';
export const DOCUMENT_YEARS_FETCH_REQUEST_SUCCESS = 'DOCUMENT_YEARS_FETCH_REQUEST_SUCCESS';

export const DOCUMENT_REVIEW_REQUEST = 'DOCUMENT_REVIEW_REQUEST';
export const DOCUMENT_REVIEW_REQUEST_SUCCESS = 'DOCUMENT_REVIEW_REQUEST_SUCCESS';
export const DOCUMENT_REVIEW_REQUEST_FAILURE = 'DOCUMENT_REVIEW_REQUEST_FAILURE';

export const GENERATE_OTP_REQUEST = 'GENERATE_OTP_REQUEST';
export const GENERATE_OTP_REQUEST_SUCCESS = 'GENERATE_OTP_REQUEST_SUCCESS';
export const GENERATE_OTP_REQUEST_FAILURE = 'GENERATE_OTP_REQUEST_FAILURE';

export const VALIDATE_OTP_REQUEST = 'VALIDATE_OTP_REQUEST';
export const VALIDATE_OTP_REQUEST_SUCCESS = 'VALIDATE_OTP_REQUEST_SUCCESS';
export const VALIDATE_OTP_REQUEST_FAILURE = 'VALIDATE_OTP_REQUEST_FAILURE';

export const SINGLE_DOCUMENT_CLEAN_REQUEST = 'SINGLE_DOCUMENT_CLEAN_REQUEST';

export const OTP_PROPS_CLEAN_REQUEST = 'OTP_PROPS_CLEAN_REQUEST';

export const DOCUMENT_RENAME_REQUEST = 'DOCUMENT_RENAME_REQUEST';
export const DOCUMENT_RENAME_REQUEST_SUCCESS = 'DOCUMENT_RENAME_REQUEST_SUCCESS';
export const DOCUMENT_RENAME_REQUEST_FAILURE = 'DOCUMENT_RENAME_REQUEST_FAILURE';

export const TAX_DOCUMENT_RE_UPLOAD_REQUEST = 'TAX_DOCUMENT_RE_UPLOAD_REQUEST';
export const TAX_DOCUMENT_RE_UPLOAD_REQUEST_SUCCESS = 'TAX_DOCUMENT_RE_UPLOAD_REQUEST_SUCCESS';
export const TAX_DOCUMENT_RE_UPLOAD_REQUEST_FAILURE = 'TAX_DOCUMENT_RE_UPLOAD_REQUEST_FAILURE';

export const PDF_MERGE_REQUEST = 'PDF_MERGE_REQUEST';
export const PDF_MERGE_REQUEST_SUCCESS = 'PDF_MERGE_REQUEST_SUCCESS';
export const PDF_MERGE_REQUEST_FAILURE = 'PDF_MERGE_REQUEST_FAILURE';

export const POLICY_DISCLAMER_REQUEST = 'POLICY_DISCLAMER_REQUEST';
export const POLICY_DISCLAMER_REQUEST_SUCCESS = 'POLICY_DISCLAMER_REQUEST_SUCCESS';
export const POLICY_DISCLAMER_REQUEST_FAILURE = 'POLICY_DISCLAMER_REQUEST_FAILURE';
export const CLEAN_POLICY_DISCLAMER = 'CLEAN_POLICY_DISCLAMER';

export const CLEAN_PDF_MERGE_PROPS = 'CLEAN_PDF_MERGE_PROPS';
export const CLEAN_TAX_DOCUMENT_RE_UPLOAD_PROPS = 'CLEAN_TAX_DOCUMENT_RE_UPLOAD_PROPS';

export const CLEAN_DOCUMENT_REVIEW_REQUEST_PROPS = 'CLEAN_DOCUMENT_REVIEW_REQUEST_PROPS';

export const DOCUMENT_SIGNATURE_UPSERT_REQUEST = 'DOCUMENT_SIGNATURE_UPSERT_REQUEST';
export const DOCUMENT_SIGNATURE_UPSERT_REQUEST_SUCCESS =
  'DOCUMENT_SIGNATURE_UPSERT_REQUEST_SUCCESS';
export const DOCUMENT_SIGNATURE_UPSERT_REQUEST_FAILURE =
  'DOCUMENT_SIGNATURE_UPSERT_REQUEST_FAILURE';

export const DOCUMENT_SIGNATURE_FETCH_REQUEST = 'DOCUMENT_SIGNATURE_FETCH_REQUEST';
export const DOCUMENT_SIGNATURE_FETCH_REQUEST_SUCCESS = 'DOCUMENT_SIGNATURE_FETCH_REQUEST_SUCCESS';
export const DOCUMENT_SIGNATURE_FETCH_REQUEST_FAILURE = 'DOCUMENT_SIGNATURE_FETCH_REQUEST_FAILURE';

export const DOCUMENT_SIGNATURE_CLEAN_REQUEST = 'DOCUMENT_SIGNATURE_CLEAN_REQUEST';

export const DOCUMENT_TRANSFER_REQUEST = 'DOCUMENT_TRANSFER_REQUEST';
export const DOCUMENT_TRANSFER_REQUEST_SUCCESS = 'DOCUMENT_TRANSFER_REQUEST_SUCCESS';
export const DOCUMENT_TRANSFER_REQUEST_FAILURE = 'DOCUMENT_TRANSFER_REQUEST_FAILURE';

export const PROFILING_STATUS_CHANGE_REQUEST = 'PROFILING_STATUS_CHANGE_REQUEST';
export const PROFILING_STATUS_CHANGE_REQUEST_SUCCESS = 'PROFILING_STATUS_CHANGE_REQUEST_SUCCESS';
export const PROFILING_STATUS_CHANGE_REQUEST_FAILURE = 'PROFILING_STATUS_CHANGE_REQUEST_FAILURE';

export const DOCUMENT_SELF_REVIEW_REQUEST = 'DOCUMENT_SELF_REVIEW_REQUEST';
export const DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS = 'DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS';
export const DOCUMENT_SELF_REVIEW_REQUEST_FAILURE = 'DOCUMENT_SELF_REVIEW_REQUEST_FAILURE';

export const UPSERT_DOCUMENT_SELF_REVIEW_REQUEST = 'UPSERT_DOCUMENT_SELF_REVIEW_REQUEST';
export const UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS =
  'UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS';
export const UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_FAILURE =
  'UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_FAILURE';

export const TAX_RETURN_VISIBILITY_REQUEST = 'TAX_RETURN_VISIBILITY_REQUEST';
export const TAX_RETURN_VISIBILITY_REQUEST_SUCCESS = 'TAX_RETURN_VISIBILITY_REQUEST_SUCCESS';
export const TAX_RETURN_VISIBILITY_REQUEST_FAILURE = 'TAX_RETURN_VISIBILITY_REQUEST_FAILURE';

export const UPSERT_TAX_RETURN_VISIBILITY_REQUEST = 'UPSERT_TAX_RETURN_VISIBILITY_REQUEST';
export const UPSERT_TAX_RETURN_VISIBILITY_REQUEST_SUCCESS =
  'UPSERT_TAX_RETURN_VISIBILITY_REQUEST_SUCCESS';
export const UPSERT_TAX_RETURN_VISIBILITY_REQUEST_FAILURE =
  'UPSERT_TAX_RETURN_VISIBILITY_REQUEST_FAILURE';

export const CLEAN_DOCUMENT_TRANSFER_PROPS = 'CLEAN_DOCUMENT_TRANSFER_PROPS';
export const CLEAN_SELF_REVIEW_DOCUMENT_PROPS = 'CLEAN_SELF_REVIEW_DOCUMENT_PROPS';
export const CLEAN_TAX_RETURN_VISIBILITY_PROPS = 'CLEAN_TAX_RETURN_VISIBILITY_PROPS';

export const REUPLOAD_DOCUMENT_REQUEST = 'REUPLOAD_DOCUMENT_REQUEST';
export const REUPLOAD_DOCUMENT_REQUEST_SUCCESS = 'REUPLOAD_DOCUMENT_REQUEST_SUCCESS';
export const REUPLOAD_DOCUMENT_REQUEST_FAILURE = 'REUPLOAD_DOCUMENT_REQUEST_FAILURE';

export const MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST = 'MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST';
export const MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_SUCCESS =
  'MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_SUCCESS';
export const MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_FAILURE =
  'MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_FAILURE';

export const NOTIFY_USER_DURING_DOCUMENT_UPLOAD = 'NOTIFY_USER_DURING_DOCUMENT_UPLOAD';
export const NOTIFY_USER_DURING_DOCUMENT_UPLOAD_SUCCESS =
  'NOTIFY_USER_DURING_DOCUMENT_UPLOAD_SUCCESS';
export const NOTIFY_USER_DURING_DOCUMENT_UPLOAD_FAILURE =
  'NOTIFY_USER_DURING_DOCUMENT_UPLOAD_FAILURE';

export const DOCUMENT_NOTE_ADD_REQUEST = 'DOCUMENT_NOTE_ADD_REQUEST';
export const DOCUMENT_NOTE_ADD_REQUEST_SUCCESS = 'DOCUMENT_NOTE_ADD_REQUEST_SUCCESS';
export const DOCUMENT_NOTE_ADD_REQUEST_FAILURE = 'DOCUMENT_NOTE_ADD_REQUEST_FAILURE';

export const DOCUMENT_NOTE_ADD_BY_BULK_REQUEST = 'DOCUMENT_NOTE_ADD_BY_BULK_REQUEST';
export const DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_SUCCESS =
  'DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_SUCCESS';
export const DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_FAILURE =
  'DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_FAILURE';

export const DOCUMENT_NOTES_FETCH_REQUEST = 'DOCUMENT_NOTES_FETCH_REQUEST';
export const DOCUMENT_NOTES_FETCH_REQUEST_SUCCESS = 'DOCUMENT_NOTES_FETCH_REQUEST_SUCCESS';
export const DOCUMENT_NOTES_FETCH_REQUEST_FAILURE = 'DOCUMENT_NOTES_FETCH_REQUEST_FAILURE';

export const DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION =
  'DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION';
export const DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_SUCCESS =
  'DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_SUCCESS';
export const DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_FAILURE =
  'DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_FAILURE';

export const DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST =
  'DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST';
export const DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_SUCCESS =
  'DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_SUCCESS';
export const DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_FAILURE =
  'DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_FAILURE';

export const DOCUMENT_DOWNLOAD_BULK_REQUEST = 'DOCUMENT_DOWNLOAD_BULK_REQUEST';
export const DOCUMENT_DOWNLOAD_BULK_REQUEST_SUCCESS = 'DOCUMENT_DOWNLOAD_BULK_REQUEST_SUCCESS';
export const DOCUMENT_DOWNLOAD_BULK_REQUEST_FAILURE = 'DOCUMENT_DOWNLOAD_BULK_REQUEST_FAILURE';

export const DOCUMENT_READ_STATUS_REQUEST = 'DOCUMENT_READ_STATUS_REQUEST';
export const DOCUMENT_READ_STATUS_REQUEST_SUCCESS = 'DOCUMENT_READ_STATUS_REQUEST_SUCCESS';
export const DOCUMENT_READ_STATUS_REQUEST_FAILURE = 'DOCUMENT_READ_STATUS_REQUEST_FAILURE';
